import React from "react";
import Types from "prop-types";
import { sharedStyles } from "./MotInvitation.shared.styles";
import CareemPartnerLogo from "../../images/icn_careem_partner_logo.svg";

const MotInvitationPageHeader = ({ t }) => (
  <header style={sharedStyles.header}>
    <div style={sharedStyles.headerBrand}>
      <div style={sharedStyles.headerLogo}>
        <img src={CareemPartnerLogo} alt="" aria-hidden="true" style={sharedStyles.headerLogoImg} />
      </div>
      <h1 style={sharedStyles.headerTitle}>
        <span style={{ fontWeight: "400" }}>Careem </span>Partner
      </h1>
    </div>
    <p style={sharedStyles.headerSubtitle}>
      {t("business_invitation:you_have_been_invited")}
    </p>
  </header>
);

MotInvitationPageHeader.propTypes = {
  t: Types.func.isRequired,
};

export default MotInvitationPageHeader;
